/**
 * A duration in milliseconds for display — the ONE duration formatter (MAR-948).
 *
 * `840 ms` under a second, then one decimal in the largest unit that fits: `1.5 s`, `1.6 min`,
 * `1.5 h`. A value that rounds up to the next unit's boundary is printed in that unit, so
 * `1000 ms` and `60.0 s` never appear. Negative or non-finite input prints as `0 ms`. What an
 * ABSENT duration looks like (`--`, nothing at all) is the caller's decision, so this takes a number.
 *
 * In `shared/` because the server formats durations too (the GPU cost report).
 * `tests/unit/formatHelpersSweep.test.ts` fails if a local copy comes back.
 */
const STEPS: ReadonlyArray<readonly [unit: string, ms: number]> = [
  ['s', 1000],
  ['min', 60_000],
  ['h', 3_600_000],
]

export function formatMs(ms: number): string {
  const value = Number.isFinite(ms) && ms > 0 ? ms : 0
  if (Math.round(value) < 1000) return `${Math.round(value)} ms`
  let step = 0
  while (step < STEPS.length - 1 && Math.round((value / STEPS[step]![1]) * 10) / 10 >= boundary(step)) {
    step += 1
  }
  const [unit, size] = STEPS[step]!
  return `${(value / size).toFixed(1)} ${unit}`
}

/** How many of this step's unit make the next one (60 s in a minute, 60 min in an hour). */
function boundary(step: number): number {
  return STEPS[step + 1]![1] / STEPS[step]![1]
}
